import { useTheme } from '@mui/material';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces/index';
import { useMytaverse } from '@providers/MytaverseProvider';
import { OrientationFromTo } from './interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();
  const titleColor = appTheme.loginPage.assets.titleColor;
  const subtitleColor = appTheme.loginPage.assets.subtitleColor;
  const { backgroundColor, backgroundColorHover } = appTheme.submitButton;

  return {
    root: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9,
      background: colors.white,
    },
    headerWrapper: {
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '0 15px',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    iconWrapper: (orientation: OrientationFromTo) => ({
      '@keyframes rotate': {
        '0%': {
          transform:
            orientation === OrientationFromTo.LANDSCAPE_TO_PORTRAIT
              ? 'rotate(90deg)'
              : 'rotate(0deg)',
        },
        '100%': {
          transform:
            orientation === OrientationFromTo.LANDSCAPE_TO_PORTRAIT
              ? 'rotate(0deg)'
              : 'rotate(-90deg)',
        },
      },
      animation: 'rotate 2s ease infinite',
    }),
    title: {
      fontFamily: 'var(--primary-font-bold)',
      fontSize: 40,
      lineHeight: '56px',
      color: titleColor,
      marginBottom: 1,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        lineHeight: '46px',
        fontSize: 32,
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        fontSize: 22,
        lineHeight: '26px',
      },
    },
    text: {
      fontSize: 20,
      lineHeight: '150%',
      maxWidth: '50%',
      textAlign: 'center',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'block',
        fontSize: '16px',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: 'block',
        fontSize: '14px',
      },
    },
    subtitle: {
      fontWeight: 600,
      color: subtitleColor,
      marginTop: 2,
    },
    message: {
      fontWeight: 700,
      marginTop: 2,
    },
    button: {
      width: '50%',
      maxWidth: '365px',
      color: colors.white,
      fontWeight: 500,
      background: backgroundColor,
      fontSize: 20,
      lineHeight: '24px',
      paddingY: '8px',
      textTransform: 'none',
      mt: '10px',

      '&:hover': {
        background: backgroundColorHover,
      },

      [`@media only screen and (max-height: 575.98px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          display: 'block',
        },
    },
  };
};
